import { useRefinementList } from 'react-instantsearch';
import InstantSearchAccordion from './units/instantSearchAccordion';
import InstantSearchFilterOption from './units/instantSearchFilterOption';
import { FilterBaseProps } from '../../types/InstantSearch';

const ColourFilter = ({ filtersOpen }: FilterBaseProps) => {
  const { items, refine } = useRefinementList({
    attribute: 'colour',
    sortBy: ['name:asc'],
    limit: 100,
  });

  if (items.length === 0) return null;

  // permanently move "Choice of colours" to the end of the list
  const optionLabelsToMoveToEnd = ['Choice of Colours', 'Other'];

  const optionsToMoveToEnd = optionLabelsToMoveToEnd
    .map((option) => items.find((item) => item.label === option))
    .filter((item) => item !== undefined);

  const filteredItems = items.filter(
    (item) => !optionLabelsToMoveToEnd.includes(item.label)
  );

  const sortedItems = [...filteredItems, ...optionsToMoveToEnd];

  const selectedOptions = items
    .reduce(
      (acc, item) => (item.isRefined ? [...acc, item.value] : acc),
      [] as string[]
    )
    .join(', ');

  return (
    <InstantSearchAccordion
      filtersOpen={filtersOpen}
      label={'Colours'}
      selectedOptions={selectedOptions}
    >
      <ul>
        {sortedItems.map(({ count, label, isRefined, value }) => (
          <InstantSearchFilterOption.CheckBox
            count={count}
            id={label}
            isSelected={isRefined}
            key={label}
            label={label}
            onChange={() => refine(value)}
          >
            <span
              className={`ac-instant-search__colour ac-instant-search__colour--${label
                .toLowerCase()
                .replace(/\s+/g, '-')}`}
            />
          </InstantSearchFilterOption.CheckBox>
        ))}
      </ul>
    </InstantSearchAccordion>
  );
};

export default ColourFilter;
